import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Drawer from "@material-ui/core/Drawer"
import Typography from "@material-ui/core/Typography"
import {
  toggleMessageDrawer,
  sendMessage,
  pushMessage,
  setActiveChatter,
  getMessages,
  removeChatter,
  setChatRead,
} from "../../actions/message-drawer"
import classNames from "classnames"
import TransitionGroup from "react-transition-group/TransitionGroup"
import MessageTransition from "../../Transitions/Message"
import update from "immutability-helper"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import Rating from "../Rating"
import Image from "../../assets/images/login_bg.jpg"
import Divider from "@material-ui/core/Divider"
import Input from "@material-ui/core/Input"
import InputAdornment from "@material-ui/core/InputAdornment"
import IconButton from "@material-ui/core/IconButton"
import SendIcon from "@material-ui/icons/Send"
import Collapse from "@material-ui/core/Collapse"
import PlaceIcon from "@material-ui/icons/Place"
import Chip from "@material-ui/core/Chip"
import FaceIcon from "@material-ui/icons/Face"
// import CloseIcon from "@material-ui/icons/Close"
import Badge from "@material-ui/core/Badge"
import { isEmpty } from "lodash"
// import Cancel from "@material-ui/icons/Cancel"
import PubNubController from "../PubNubController"
import CircularProgress from "@material-ui/core/CircularProgress"
import moment from "moment"
import { addRating } from "../../actions/misc"

class MessageDrawerComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      message: "",
      expanded: false,
      speedDialOpen: false,
    }
    this.pubNub = null

    this.setPubNubRef = element => {
      this.pubNub = element
    }
  }
  setScroll = () => {
    const wrapper = document.getElementById("messages-wrapper")
    if (wrapper) {
      wrapper.scrollTop = wrapper.scrollHeight
    }
  }
  handlePubNubMessage = (message, userId) => {
    this.props.dispatch(pushMessage(userId, message))
    if (this.props.open && this.props.activeChatter === userId) {
      this.setScroll()
    }
  }
  handleChange = event => {
    this.setState({ message: event.target.value })
  }
  handleExpandClick = () => {
    this.setState({
      expanded: !this.state.expanded,
    })
  }
  handleChipDelete = () => { }
  toggleDrawer = boolean => {
    if (boolean === false) {
      this.setState({
        speedDialOpen: boolean,
      })
    }
    this.props.dispatch(toggleMessageDrawer(boolean))
  }
  rendered = data => {
    if (
      this.props.activeChatter &&
      !this.props.activeChats.find(c => c.id === this.props.activeChatter)
        .loadedMessages
    ) {
      if (
        this.props.activeChats.find(c => c.id === this.props.activeChatter)
          .messages[0] !== "LOADING"
      ) {
        this.setScroll()
      }
      this.props
        .dispatch(
          getMessages(this.props.activeChatter, this.props.activeCompany)
        )
        .then(() => {
          const wrapper = document.getElementById("messages-wrapper")
          if (wrapper) {
            wrapper.scrollTop = wrapper.scrollHeight
          }
        })
    } else {
      this.props.dispatch(setChatRead(this.props.activeChatter))
      this.setScroll()
    }
    setTimeout(() => {
      this.setState({
        speedDialOpen: true,
      })
    }, this.props.theme.transitions.duration.enteringScreen + 100)
  }
  handleFormSubmit = e => {
    e.preventDefault()
    this.props
      .dispatch(
        sendMessage(
          this.props.activeChatter,
          this.props.activeCompany,
          this.state.message
        )
      )
      .then(() => {
        this.setState(
          update(this.state, {
            message: {
              $set: "",
            },
          })
        )
        this.setScroll()
      })
  }
  ratingChanged = value => {
    const user = this.props.activeChats.find(
      c => c.id === this.props.activeChatter
    )
    let existingRating
    if (this.props.activeCompany) {
      existingRating = user.ratings.find(
        r => r.company_id === this.props.activeCompany
      )
    } else {
      existingRating = user.ratings.find(
        r => r.creator_id === this.props.authenticatedUser.id
      )
    }
    let ratingId = undefined
    if (existingRating) {
      ratingId = existingRating.id
    }
    this.props.dispatch(
      addRating(
        value,
        ratingId,
        user.id,
        this.props.authenticatedUser,
        this.props.activeCompany
      )
    )
  }
  removeChatter = chatter => {
    this.props.dispatch(removeChatter(chatter.id))
  }
  switchActiveChatter = chatter => {
    this.props.dispatch(setActiveChatter(chatter))
    this.props.dispatch(setChatRead(chatter.id))
    if (!this.props.activeChats.find(c => c.id === chatter.id).loadedMessages) {
      this.props.dispatch(getMessages(chatter.id, this.props.activeCompany))
    }
  }
  generateAvatar = chatter => {
    if (!isEmpty(chatter.profile_image)) {
      return (
        <img
          onClick={() => this.switchActiveChatter(chatter)}
          className={this.props.classes.avatarImage}
          src={`https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
            }/image/upload/c_thumb,g_face:auto,z_0.7,h_120,w_120,fl_lossy,f_auto/v${chatter.profile_image.version
            }/${chatter.profile_image.public_id}.${chatter.profile_image.format}`}
          alt={`${chatter.first_name} ${chatter.last_name}`}
        />
      )
    } else {
      return <FaceIcon onClick={() => this.switchActiveChatter(chatter)} />
    }
  }
  render() {
    const activeChatterObj =
      this.props.activeChats.find(c => c.id === this.props.activeChatter) || {}
    const unread = this.props.activeChats.map(chat => {
      return {
        id: chat.id,
        unread: chat.messages.filter(
          message =>
            message.From === chat.phone &&
            message.body !== "LOADING" &&
            moment(message.DateCreated).diff(chat.readMessages) > 0
        ).length,
      }
    })
    // const actions = this.props.activeChats.map(chatter => ({
    //   icon: (
    //     <Badge
    //       badgeContent={unread.find(u => u.id === chatter.id).unread}
    //       color="secondary"
    //       classes={{
    //         root: this.props.classes.actionBadgeRoot,
    //         badge: classNames(this.props.classes.actionBadge, {
    //           [this.props.classes.messageDrawerButtonBadgeZoomOut]:
    //             unread.find(u => u.id === chatter.id).unread === 0,
    //           [this.props.classes.messageDrawerButtonBadgeZoomIn]:
    //             unread.find(u => u.id === chatter.id).unread > 0
    //         })
    //       }}
    //     >
    //       <div className={this.props.classes.closeIconWrapper}>
    //         <Cancel
    //           className={this.props.classes.closeIcon}
    //           onClick={() => this.removeChatter(chatter)}
    //         />
    //       </div>
    //       {this.generateAvatar(chatter)}
    //     </Badge>
    //   ),
    //   name: `${chatter.first_name} ${chatter.last_name}`
    // }))
    const messages = activeChatterObj.messages
    let companyRating = undefined
    let myRating = undefined
    let selectedRating = 0
    if (!isEmpty(activeChatterObj) && activeChatterObj.ratings) {
      companyRating = activeChatterObj.ratings.find(
        r => r.company_id === this.props.activeCompany
      )
      myRating = activeChatterObj.ratings.find(
        r => r.creator_id === this.props.authenticatedUser.id
      )
      if (companyRating) {
        selectedRating = companyRating.score
      } else if (myRating) {
        selectedRating = myRating.score
      }
    }
    return (
      <Fragment>
        <Drawer
          anchor="right"
          open={this.props.open}
          classes={{
            paper: classNames(this.props.classes.drawer, {
              [this.props.classes.drawerOpen]: this.props.open,
            }),
          }}
          onClose={() => this.toggleDrawer(false)}
          ModalProps={{
            onRendered: this.rendered,
          }}
        >
          <div
            tabIndex={0}
            role="button"
            className={classNames(this.props.classes.flex, {
              [this.props.classes.flexCenter]: !this.props.activeChatter,
            })}
          >
            {!isEmpty(activeChatterObj) && (
              <Fragment>
                <div className={this.props.classes.mainArea}>
                  <CardMedia
                    className={this.props.classes.media}
                    image={
                      !isEmpty(activeChatterObj.profile_image)
                        ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                        }/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${activeChatterObj.profile_image.version
                        }/${activeChatterObj.profile_image.public_id}.${activeChatterObj.profile_image.format
                        }`
                        : Image
                    }
                    title={`${activeChatterObj.first_name} ${activeChatterObj.last_name
                      }`}
                  >
                    <div className={this.props.classes.mediaContent}>
                      <Typography
                        gutterBottom
                        variant="h5"
                        color="inherit"
                        component="h2"
                        className={this.props.classes.cardHeadline}
                      >
                        {activeChatterObj.first_name}{" "}
                        {activeChatterObj.last_name}
                      </Typography>
                      {this.props.activeChatter &&
                        activeChatterObj.locations.length > 0 &&
                        activeChatterObj.locations[0].hasOwnProperty(
                          "city"
                        ) && (
                          <div className={this.props.classes.primaryPlace}>
                            <PlaceIcon
                              className={this.props.classes.placeIcon}
                            />
                            <Typography
                              variant="caption"
                              className={this.props.classes.placeName}
                              color="inherit"
                            >
                              {activeChatterObj.locations[0].label}
                            </Typography>
                          </div>
                        )}
                    </div>
                  </CardMedia>
                  <CardContent
                    classes={{ root: this.props.classes.cardContentRoot }}
                  >
                    <div className={this.props.classes.ratingWrapper}>
                      {this.props.activeChatter && (
                        <Rating
                          avgRating={activeChatterObj.avg_rating}
                          userId={this.props.activeChatter}
                          totalRatings={
                            activeChatterObj.ratings.filter(r => r.score > -1)
                              .length
                          }
                          selectedRating={selectedRating}
                          ratingChanged={this.ratingChanged}
                        />
                      )}
                      {/*
                      <IconButton
                        className={classNames(this.props.classes.expand, {
                          [this.props.classes.expandOpen]: this.state.expanded,
                        })}
                        onClick={this.handleExpandClick}
                        aria-expanded={this.state.expanded}
                        aria-label="Show more"
                      >
                        <ExpandMoreIcon />
                      </IconButton>*/}
                    </div>
                    <Collapse in={this.state.expanded} timeout="auto">
                      <div className={this.props.classes.chipWrapper}>
                        <Chip
                          label="Producer"
                          onClick={this.handleChipClick}
                          onDelete={this.handleChipDelete}
                          className={this.props.classes.chip}
                          classes={{
                            deleteIcon: this.props.classes.chipDeleteIcon,
                          }}
                        />
                        <Chip
                          label="Atlanta, GA"
                          onClick={this.handleChipClick}
                          onDelete={this.handleChipDelete}
                          className={this.props.classes.chip}
                          classes={{
                            deleteIcon: this.props.classes.chipDeleteIcon,
                          }}
                        />
                      </div>
                    </Collapse>
                  </CardContent>
                  <Divider />
                  {messages.length === 0 && (
                    <div className={this.props.classes.noMessages}>
                      <Typography
                        variant="display1"
                        className={this.props.classes.noMessagesText}
                      >
                        No messages with this user
                      </Typography>
                    </div>
                  )}
                  {messages.length > 0 && (
                    <Fragment>
                      {messages[0] === "LOADING" && (
                        <div className={this.props.classes.spinnerWrapper}>
                          <CircularProgress color="primary" />
                        </div>
                      )}
                      {messages[0] !== "LOADING" && (
                        <TransitionGroup
                          id="messages-wrapper"
                          className={this.props.classes.messagesWrapper}
                        >
                          {messages.map((m, i) => {
                            return (
                              <MessageTransition key={i} duration={300}>
                                <div
                                  className={
                                    this.props.classes[
                                    `${m.From === activeChatterObj.phone
                                      ? "to"
                                      : "from"
                                    }Me`
                                    ]
                                  }
                                >
                                  <Typography
                                    className={this.props.classes.messageTime}
                                  >
                                    {moment(m.DateCreated).format(
                                      "MMMM D, YYYY, h:mm a"
                                    )}
                                  </Typography>
                                  <div
                                    className={
                                      this.props.classes.messageBubbleWrapper
                                    }
                                  >
                                    <Typography
                                      className={
                                        this.props.classes.messageBubble
                                      }
                                    >
                                      {m.Body}
                                    </Typography>
                                  </div>
                                </div>
                              </MessageTransition>
                            )
                          })}
                        </TransitionGroup>
                      )}
                    </Fragment>
                  )}
                </div>
                <form
                  onSubmit={this.handleFormSubmit}
                  className={this.props.classes.inputArea}
                  autoComplete="off"
                >
                  <Divider />
                  <Input
                    fullWidth
                    id="send-message"
                    type="text"
                    value={this.state.message}
                    onChange={this.handleChange}
                    className={this.props.classes.input}
                    autoComplete="nope"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          type="submit"
                          aria-label="Send Message"
                          disabled={messages[0] === "LOADING"}
                        >
                          <SendIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </form>
              </Fragment>
            )}
            {!this.props.activeChatter && (
              <Typography
                variant="display1"
                className={this.props.classes.noChatsMessage}
              >
                You have no active chats
              </Typography>
            )}
          </div>
        </Drawer>
        {this.props.accessLevel === 1 && (
          <div
            className={classNames(
              this.props.classes.messageDrawerButtonWrapper,
              {
                [this.props.classes.messageDrawerButtonWrapperOpen]: this.props
                  .open,
              }
            )}
          >
            <Badge
              badgeContent={unread
                .map(({ unread }) => unread)
                .reduce((a, b) => a + b, 0)}
              color="secondary"
              classes={{
                badge: classNames(this.props.classes.messageDrawerButtonBadge, {
                  [this.props.classes.messageDrawerButtonBadgeZoomOut]:
                    unread
                      .map(({ unread }) => unread)
                      .reduce((a, b) => a + b, 0) === 0,
                  [this.props.classes.messageDrawerButtonBadgeZoomIn]:
                    unread
                      .map(({ unread }) => unread)
                      .reduce((a, b) => a + b, 0) > 0,
                }),
              }}
            >
              {/* <SpeedDial
                ariaLabel="SpeedDial example"
                icon={
                  <SpeedDialIcon
                    icon={<MessageIcon style={{ color: "white" }} />}
                    openIcon={<CloseIcon style={{ color: "white" }} />}
                  />
                }
                onClick={() => this.toggleDrawer(!this.props.open)}
                open={this.state.speedDialOpen}
              >
                {actions.map(action => (
                  <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={action.name}
                    classes={{
                      button: this.props.classes.speedDialActionButton
                    }}
                  />
                ))}
              </SpeedDial> */}
            </Badge>
          </div>
        )}
        {
          !(window.location.href.includes("billing")) && this.props.activeChats.map(chatter => {
            return (
              <PubNubController
                key={chatter.id}
                channelName={`sms_channel_${1}_${chatter.id}`}
                ref={this.setPubNubRef}
                onAction={message =>
                  this.handlePubNubMessage(message, chatter.id)
                }
              />
            )
          })}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.messageDrawer.open,
    activeChatter: state.messageDrawer.activeChatter,
    activeChats: state.messageDrawer.activeChats,
    messages: state.messageDrawer.messages,
    authenticatedUser: state.authentication.authenticatedUser,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(MessageDrawerComponent)
